<script setup lang="ts">
import { ChevronRightIcon } from '@heroicons/vue/24/solid'
import type { PostStoryblok } from '~/types/storyblok'
import UiSpinner from '~/components/Ui/UiSpinner.vue'

const props = withDefaults(
  defineProps<{
    searchString: string
    take: number
  }>(),
  {
    take: 8,
  },
)

const searchTerm = ref(props.searchString)

const { stories, loading, fetchStories, reset } = useStoryblokSearch<PostStoryblok>({
  contentType: 'post',
  perPage: props.take,
  searchTerm,
})

watch(
  () => props.searchString,
  (newValue) => {
    searchTerm.value = newValue
    reset()
    fetchStories()
  },
)

await fetchStories()
</script>

<template>
  <section>
    <h3 class="mb-2 text-2xl font-semibold">Blogginlägg</h3>
    <UiSpinner v-if="loading" />
    <div v-else-if="!loading && !stories.length" class="italic">Inga blogginlägg hittades</div>
    <ul v-else role="list">
      <li v-for="item in stories" :key="item.id">
        <NuxtLink :to="item.full_slug" class="group flex items-center py-2 transition-colors hover:text-midnight-600">
          <span class="mr-3 w-[30px]">
            <SvgoIconArticle filled />
          </span>
          <span class="mr-5">{{ item.name }}</span>
          <ChevronRightIcon class="ml-auto size-[15px] transition-transform ease-in-out group-hover:translate-x-1" />
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>
